
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export function AssessmentsActions() {
  return (
    <div className="flex justify-end">
      <Button asChild className="h-10 sm:h-11 px-4 sm:px-6 text-sm sm:text-base touch-manipulation">
        <Link to="/admin/assessments/create">
          <PlusCircle className="mr-2 h-4 w-4" />
          <span className="hidden xs:inline">New Assessment</span>
          <span className="xs:hidden">New</span>
        </Link>
      </Button>
    </div>
  );
}
